import { Add, Delete, Edit } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { useOfferMailOrderShipmentsWithBtoAmt } from "../../common/enum";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { SpecialActionDto } from "./types";
import { SpecialActionDialog } from "./SpecialActionDialog";

export function SpecialActionListPage() {
    const [useStore] = useState(() => createListStore<SpecialActionDto>({
        path: "settings/specialActions",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "name", label: "Name", width: 250 },
            { column: "fromDate", label: "Valid from", width: 120, type: "date" },
            { column: "toDate", label: "Valid to", width: 120, type: "date" },
            { column: "template1OfferMailOrderShipmentId", label: "MO 1", width: 300, enumStore: useOfferMailOrderShipmentsWithBtoAmt },
            { column: "template2OfferMailOrderShipmentId", label: "MO 2", width: 300, enumStore: useOfferMailOrderShipmentsWithBtoAmt },
            { column: "template3OfferMailOrderShipmentId", label: "MO 3", width: 300, enumStore: useOfferMailOrderShipmentsWithBtoAmt },
            { column: "description", label: "Description", width: 200 },
        ],
    }));

    const { selectedItem } = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteItem() {
        await simpleDialog.show("Special actions", "Delete selected special action?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/specialActions/${selectedItem!.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <SpecialActionDialog close={close} specialAction={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const editDialog = useDialog(close => <SpecialActionDialog close={close} specialAction={selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Special actions" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={selectedItem == null} title="Delete" onClick={deleteItem}><Delete /></Button>],
            ]),
        })}
    </>;
}
